import React, { useEffect, useState } from 'react';

import { Col, Row, Form } from 'react-bootstrap';

import './styles.css';

import Menu from '../../components/Menu';
import { Link, useHistory, useParams } from 'react-router-dom';
import api from '../../services/api';
import { useAlert } from 'react-alert';
import { readFile } from '../../useful/helpers';
import CropperModal from '../../components/CropperModal';

const EditBiblioteca = () => {
    const [thumbnail, setThumbnail] = useState(null);
    const [uploadImage, setUploadImage] = useState(null);
    const [title, setTitle] = useState('');
    const [tags, setTags] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState('');
    const [formData, setFormData] = useState(null);
    const [load, setLoad] = useState(false);
    const [show, setShow] = useState(false);
    const [imageCrop, setImageCrop] = useState(null);

    const alert = useAlert();
    const history = useHistory();
    const { id } = useParams();

    useEffect(() => {
        const getLibrary = async () => {
            try {
                const { status, data } = await api.get(`admin/library/${id}`);
                if (status === 200) {
                    setTitle(data.resource.title);
                    setTags(data.resource.tags);
                    setDescription(data.resource.description);
                    setThumbnail(data.resource.url_thumbnail);
                } else {
                    history.push("/biblioteca");
                }
            } catch (error) {
                console.log(error.response);
            }
        }
        getLibrary();

        setFormData(new FormData());
    }, []);

    const handleTitle = e => setTitle(e.target.value);
    const handleTags = e => setTags(e.target.value);
    const handleDescription = e => setDescription(e.target.value);
    const handleImage = async e => {
        setImage(e.target.value);
        let imageDataUrl = await readFile(e.target.files[0]);
        setImageCrop(imageDataUrl);
        setShow(true);
    }
    const handleThumbnail = (value) => {
        setThumbnail(value);
        setUploadImage(value);
    }


    const handleSubmit = async () => {
        setLoad(true);
        formData.append('title', title);
        formData.append('tags', tags);
        formData.append('description', description);
        if (uploadImage !== null) {
            formData.append('image', uploadImage);
        }
        formData.append('_method', 'put');


        try {
            const { status } = await api.post(`admin/library/${id}`, formData);
            setLoad(false);
            if (status === 201) {
                alert.show("Dados atualizados com sucesso!");
                history.push("/biblioteca");
            }
        } catch ({ response }) {
            setLoad(false);
            const { status, data } = response;
            if (status === 401) {
                for (let item in data.message) {
                    alert.show(data.message[item][0]);
                }
            }
        }

    }

    return (
        <div className="container-fluid">
            {load &&
                <div className="load">
                    <div className="loading"></div>
                </div>
            }
            <Menu />
            <div className="content">
                <Row>
                    <Col sm={12} className="col-title">
                        <div className="titlePages">
                            <h5>Biblioteca</h5>
                            <Link to="/biblioteca">
                                <button className="btnBorder">VOLTAR</button>
                            </Link>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <Form className="formNew">
                            <Row>
                                <Col sm={6}>
                                    <Form.Group>
                                        <Form.Label>Título</Form.Label>
                                        <Form.Control type="text" name="title" value={title} onChange={handleTitle} placeholder="Inserir aqui" />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group>
                                        <Form.Label>Título</Form.Label>
                                        <Form.Control type="text" name="tags" value={tags} onChange={handleTags} placeholder="Inserir aqui" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={6}>
                                    <Form.Group>
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control as="textarea" rows={6} name="description" value={description} onChange={handleDescription} placeholder="Inserir aqui" />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group>
                                        <Form.File label="Faça upload da imagem (ideal: 1.000 x 1.000 px)" name="image" value={image} onChange={handleImage} />
                                    </Form.Group>
                                    {imageCrop &&
                                        <CropperModal
                                            show={show}
                                            image={imageCrop}
                                            setCroppedImage={handleThumbnail}
                                        />
                                    }
                                    <img src={thumbnail} className="thumbnail" alt={title} />
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <hr className="hrBorder" />
                <Row>
                    <Col sm={8}>
                        <button className="btnYellow btnFloat" onClick={handleSubmit}>SALVAR</button>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default EditBiblioteca;